/* eslint-disable arrow-body-style */
import http from "./utils";
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { prefix } from './constants';

export const getDataMapSource: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/datamap/opinions/source`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getDataMapNews: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/datamap/opinions/news`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};
